'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeByType = exports.hideConfirm = exports.showConfirm = exports.remove = exports.clean = undefined;
exports.add = add;

var _constants = require('./constants');

var _utils = require('./utils');

var _reducer = require('./reducer');

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function add(toastr) {
  if (_config2.default.preventDuplicates && (0, _utils.preventDuplication)(_reducer.toastrsCache, toastr)) {
    return {
      type: _constants.ADD_TOASTR,
      payload: {
        ignoreToastr: true
      }
    };
  }
  return {
    type: _constants.ADD_TOASTR,
    payload: toastr
  };
}

var clean = exports.clean = function clean() {
  return {
    type: _constants.CLEAN_TOASTR
  };
};

var remove = exports.remove = function remove(params) {
  return {
    type: _constants.REMOVE_TOASTR,
    payload: params
  };
};

var showConfirm = exports.showConfirm = function showConfirm(obj) {
  return {
    type: _constants.SHOW_CONFIRM,
    payload: obj
  };
};

var hideConfirm = exports.hideConfirm = function hideConfirm() {
  return { type: _constants.HIDE_CONFIRM };
};

var removeByType = exports.removeByType = function removeByType(payload) {
  return {
    type: _constants.REMOVE_BY_TYPE,
    payload: payload
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/_react-redux-toastr@5.0.0@react-redux-toastr/lib/actions.js
// module id = 679
// module chunks = 0